import React from 'react';
import { Control } from 'react-hook-form';
import Typography from '@material-ui/core/Typography';
import { useMediaQuery } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import ProjectFilePathField from './ProjectFilePathField';
import FormDatePicker from './FormDatePicker';

export const QUALITY_CONTROL_PHASE_COLUMNS: Array<{ key: string; label: string }> = [
  { key: 'Sd', label: 'SD' },
  { key: 'Dd', label: 'DD' },
  { key: 'Cd', label: 'CD' },
  { key: 'SsDocs', label: 'S/S DOCS' },
];

export const QUALITY_CONTROL_PHASE_ROWS: Array<{
  key: string;
  label: string;
  isDate?: boolean;
}> = [
  { key: 'phaseDueDate', label: 'Phase Due Dates', isDate: true },
  { key: 'designReview', label: 'Design Review / Design Standards Review' },
  { key: 'buildingCodeReview', label: 'Building Code / Zoning Review' },
  { key: 'qaReviews', label: 'QA Reviews / Red-lines Back Checked' },
  { key: 'qcPeerReview', label: 'QC Peer Review' },
];

export const QUALITY_CONTROL_PHASE_GRID_COLUMNS = '1.6fr repeat(4, 1fr)';

// This section is laid out by hand rather than through FormGrid, so it carries its own print
// tightening. Same values, reached through MUI's stable global class names.
const useStyles = makeStyles(() =>
  createStyles({
    row: {
      '@media print': {
        marginBottom: '3px !important',
        '& .MuiOutlinedInput-input': {
          paddingTop: 6,
          paddingBottom: 6,
        },
        '& .MuiSelect-select': {
          paddingTop: 6,
          paddingBottom: 6,
        },
      },
    },
  }),
);

export default function ProjectQualityControlPhaseRow({
  control,
  rowKey,
  label,
  isDate,
}: {
  control: Control<any>;
  rowKey: string;
  label: string;
  isDate?: boolean;
}) {
  const isMobile = useMediaQuery('(max-width: 800px)');
  const classes = useStyles();

  const fields = QUALITY_CONTROL_PHASE_COLUMNS.map((column) => {
    const name = `${rowKey}${column.key}`;

    return isDate ? (
      <FormDatePicker
        key={name}
        name={name}
        control={control}
        label={isMobile ? column.label : undefined}
      />
    ) : (
      <ProjectFilePathField
        key={name}
        name={name}
        control={control}
        label={isMobile ? column.label : undefined}
        InputLabelProps={isMobile ? { shrink: true } : undefined}
      />
    );
  });

  if (isMobile) {
    return (
      <>
        <Typography style={{ fontWeight: 500 }}>{label}:</Typography>
        <div
          className={classes.row}
          style={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            alignItems: 'center',
            gap: '12px',
            marginBottom: 8,
          }}
        >
          {fields}
        </div>
      </>
    );
  }

  return (
    <div
      className={classes.row}
      style={{
        display: 'grid',
        gridTemplateColumns: QUALITY_CONTROL_PHASE_GRID_COLUMNS,
        alignItems: 'center',
        columnGap: '12px',
        marginBottom: 8,
      }}
    >
      <Typography style={{ fontWeight: 500 }}>{label}:</Typography>
      {fields}
    </div>
  );
}
